const resetFilter = ({
  searchQueryParams,
  setSearchParams,
  setInitFilterValues,
  navigationSource = null,
  multipleSources = null,
  callbacks = [],
  resetIsManuallyTriggered = true,
  setSearchTerm = () => {},
}) => {
  if (!resetIsManuallyTriggered) {
    return;
  }

  const queryParams = {};

  Array.from(searchQueryParams.entries())
    .forEach(([ key, value ]) => {
      if (key === 'search') {
        if (navigationSource) {
          queryParams[key] = `source:${navigationSource}`;
        }
        return;
      }

      queryParams[key] = key === 'page' ? 1 : value;
    });

  setSearchParams(queryParams);
  if (multipleSources) {
    setInitFilterValues({ 'source': multipleSources.split(',') });
  } else {
    setInitFilterValues({});
  }
  setSearchTerm('');
  callbacks.forEach((callback) => callback());
};

export default resetFilter;
